import React, { useRef, useState } from "react";
import { Col, Container, Form, Row, Button } from "react-bootstrap";
import contactImg from "../image/contact.jpg";
import emailjs from "emailjs-com";
import { Alert } from "@mui/material";

const Contact = () => {
  const [emaildata, setemaildata] = useState({});
  const [success, setsucces] = useState(false);
  const handlechange = (e) => {
    const data = { ...emaildata };
    const name = e.target.name;
    const value = e.target.value;
    data[name] = value;
    console.log(data);
    setemaildata(data);
  };
  const handlesubmit = (e) => {
    e.preventDefault();
    console.log(emaildata);

    emailjs
      .sendForm(
        "service_jkpjz4h",
        "template_ridxc89",
        e.target,
        "user_sLAy6xyJiefeOWeb3e84s"
      )
      .then(
        (result) => {
          console.log(result.text);
          setsucces(true);
          setemaildata({});
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <>
      <div className=" row " id="contact">
        <div className="col-md-10 col-sm-11 mx-auto ">
          <div className="mt-5 pt-3 shadow-sm bg-white">
            <h1 className="text-center mb-3">Contact With Me</h1>
            <hr className="w-25 mx-auto" />
            <form onSubmit={handlesubmit}>
              <Container>
                <Row>
                  <Col sm={12} lg={6} className=" ">
                    <img className="w-100" src={contactImg} alt="" />
                  </Col>
                  <Col className=" pt-5 mx-auto  mt-5" sm={10} lg={6}>
                    <Row>
                      <Col sm={10} md={6} className="mx-auto my-3">
                        <Form.Control
                          onChange={handlechange}
                          name="name"
                          placeholder="Enter Your Name"
                        />
                      </Col>
                      <Col sm={10} md={6} className="mx-auto my-3">
                        <Form.Control
                          onChange={handlechange}
                          name="email"
                          placeholder="Enter Your Email"
                        />
                      </Col>
                      {/* <Col sm={10} md={6} className="mx-auto my-3">
                      <Form.Control
                        onChange={handlechange}
                        name="phone"
                        placeholder="Enter Your Phone Number"
                      />
                    </Col>
                    <Col sm={10} md={6} className="mx-auto my-3">
                      <Form.Control
                        onChange={handlechange}
                        name="adress"
                        placeholder="Enter Your Adress"
                      />
                    </Col> */}
                      <Col sm={10} md={12} className="mx-auto my-3">
                        <Form.Control
                          onChange={handlechange}
                          name="message"
                          as="textarea"
                          rows={3}
                        />
                      </Col>

                      <Button type="submit" variant="info" size="md">
                        submit
                      </Button>
                      {success ? (
                        <Alert severity="success" className="mt-3">
                          Your Email Successfully Sent ...
                        </Alert>
                      ) : (
                        ""
                      )}
                    </Row>
                  </Col>
                </Row>
              </Container>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
